var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxCalendarCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 3.33464H14.1667V1.66797H12.5V3.33464H7.5V1.66797H5.83333V3.33464H4.16667C3.2475 3.33464 2.5 4.08214 2.5 5.0013V16.668C2.5 17.5871 3.2475 18.3346 4.16667 18.3346H15.8333C16.7525 18.3346 17.5 17.5871 17.5 16.668V5.0013C17.5 4.08214 16.7525 3.33464 15.8333 3.33464ZM15.835 16.668H4.16667V6.66797H15.8333L15.835 16.668Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16729 14.5123L13.9231 9.75646L12.7448 8.57812L9.16729 12.1556L7.25646 10.2448L6.07812 11.4231L9.16729 14.5123Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxCalendarCheck);
export default __webpack_public_path__ + "static/media/bx-calendar-check.40577879ede4a3b16327cb77c94396a3.svg";
export { ForwardRef as ReactComponent };